<template>
  <div class="bottom_tree_table">
    <div class="bottom_left">
      <div class="left_button">
        <el-button v-if="addTemplate" :disabled="isSpec == undefined" type="primary" size="small" icon="el-icon-plus"
          style="width: 98%" @click="addTreeTemplate">
          新建目录模板
        </el-button>
      </div>
      <div class="left_tree">
        <el-tree ref="depTree" :data="frameTree" :accordion="true" :props="defaultProps" :expand-on-click-node="true"
          :default-expanded-keys="defaultExpandedKeys" class="tree_1" highlight-current node-key="id"
          @current-change="currentOrgChangeHandler">
          <template #default="{ data, node }">
            <span :style="{ 'padding-right': node.level > 1 ? '35px' : '0' }" class="left_tree_item"
              style="display: flex; align-items: center; position: relative">
              <img :src="getIcon(node.level)" style="margin-right: 6px" alt="" />
              <span :title="data.name" class="textAll">{{ data.name }}</span>
              <span v-if="node.level > 1" class="left_tree_item_btn">
                <i v-if="renameTemplate" class="el-icon-edit-outline" @click="renameTemplateBtn(data)"></i>
                <i v-if="deleTemplate" class="el-icon-delete" @click="deleteTemplate(data)"></i>
              </span>
            </span>
          </template>
        </el-tree>
      </div>
    </div>
    <div class="bottom_right">
      <div class="right_button" style="display: inline-block">
        <el-button v-if="copyTemplate" :disabled="isSpec == 1" type="primary" size="small" plain
          @click="copyTemplateBtn">
          复制模板
        </el-button>
        <el-button v-if="pasteTemplate" :disabled="isSpec == 1 || !templateIDCope" type="primary" size="small" plain
          @click="pasteTemplateBtn">
          粘贴模板
        </el-button>
        <el-button v-if="peeraddFloder" :disabled="!templateID || isSpec == 1" type="primary" size="small" plain
          @click="peerAddBtn">
          添加
        </el-button>
      </div>
      <div class="right_table">
        <el-table v-loading="loading" :data="folderTable" border :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          :expand-row-keys="expandRowKeys" highlight-current-row row-key="folderID" height="100%" class="treeTab"
          @current-change="handleDelete" @expand-change="expandChange">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              暂无数据
            </p>
          </template>
          <el-table-column label="文件夹名称" prop="folderName" min-width="200px">
            <template #default="{ row }">
              <el-link v-if="editFloder" type="primary" @click="updateBtn(row)">
                <span class="tabLinkSpan" :title="row.folderName">{{ row.folderName }}</span>
              </el-link>
              <span v-else class="tabLinkSpan" :title="row.folderName">{{ row.folderName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="folderNameCn" min-width="200px" />
          <el-table-column label="创建时间" prop="operDate" min-width="200px" />
          <el-table-column fixed="right" label="操作" min-width="280">
            <template #default="{ row }">
              <el-button v-if="peeraddFloder" type="text" size="small" title="添加同级" icon="el-icon-circle-plus-outline"
                @click="peerAddBtn(row)"></el-button>
              <el-button v-if="downaddFloder" type="text" size="small" title="添加子级" icon="el-icon-plus"
                @click="DemoteAddBtn(row)">
              </el-button>
              <el-button v-if="editFloder" type="text" size="small" title="编辑" icon="el-icon-edit-outline"
                @click="updateBtn(row)">
              </el-button>
              <el-button v-if="deleFloder" type="text" size="small" title="删除" icon="el-icon-delete"
                @click="deleteFileBtn(row)">
              </el-button>
              <el-button v-if="moveUpFloder" type="text" size="small" title="上移" icon="el-icon-upload2"
                @click="upmoveBtn(true, row)">
              </el-button>
              <el-button v-if="moveDownFloder" type="text" size="small" title="下移" icon="el-icon-download"
                @click="downmoveBtn(false, row)">
              </el-button>
              <el-button type="text" size="small" title="升级" icon="el-icon-sort-up" @click="upgradeBtn(0, row)">
              </el-button>
              <el-button type="text" size="small" title="降级" icon="el-icon-sort-down" @click="upgradeBtn(1, row)">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 添加模板 -->
    <el-dialog v-dialogDrag :title="templateTitle" :visible.sync="templateDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="getReset" width="600px">
      <el-form ref="fileForm" :model="fileForm" :rules="rules" class="demo-form-inline" label-width="135px"
        label-position="top" size="small">
        <el-form-item label="文件夹名称" prop="folderName">
          <el-input ref="folderName" v-model="fileForm.folderName" maxlength="50" show-word-limit placeholder="请输入文件夹名称" size="small" />
        </el-form-item>
        <el-form-item label="文件夹备注" prop="folderNameCn">
          <el-input v-model="fileForm.folderNameCn" :autosize="{ minRows: 2, maxRows: 6 }" maxlength="200"
            type="textarea" placeholder="请输入文件夹备注" size="small" />
        </el-form-item>
        <el-form-item v-if="templateType != 2" label="上级文件夹" prop="parentID">
          <el-cascader v-model="fileForm.parentID" :show-all-levels="false" :options="folderTable" :props="{
            checkStrictly: true,
            label: 'folderName',
            value: 'folderID',
          }" clearable placeholder="请选择上级文件夹" style="width: 100%" size="small"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getReset">取 消</el-button>
        <el-button v-if="templateType == 0" type="primary" size="small" @click="addtemplateBtn">确 定</el-button>
        <el-button v-if="templateType == 1" type="primary" size="small" @click="demoteAddTemplateBtn">确 定</el-button>
        <el-button v-if="templateType == 2" type="primary" size="small" @click="updateAddTemplateBtn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog v-dialogDrag :title="templateTitleCat" :visible.sync="treeAddDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="treeGetReset" width="600px">
      <el-form ref="treeForm" :model="treeForm" :rules="treeRules" class="demo-form-inline" label-width="135px"
        label-position="top" size="small">
        <el-form-item label="模板名称" prop="folderName">
          <el-input ref="folderName" v-model="treeForm.folderName" maxlength="50" show-word-limit placeholder="请输入模板名称" size="small" />
        </el-form-item>

        <el-form-item label="所属专业" prop="folderSpec">
          <el-select v-model="treeForm.folderSpec" placeholder="请选择所属专业" style="width: 100%" size="small">
            <el-option v-for="(item, index) in frameTree" :key="index" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="treeGetReset">取 消</el-button>
        <el-button type="primary" size="small" @click="templateBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import templateDirectory from "@/CommonDP/service/templateDirectory-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
import { storage } from "@/CommonDP/utils";
const newEmptyStandardForm = () => ({
  folderName: "",
  folderNameCn: "",
  parentID: ""
});
export default {
  name: "TemplateDirectory",
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      rules: {
        folderName: [{ required: true, message: "请输入文件夹名称", trigger: "blur" }],
        folderNameCn: [{ required: true, message: "请输入备注", trigger: "blur" }]
      },
      defaultProps: {
        children: "children",
        label: "name"
      },
      frameTree: [], // 树
      defaultExpandedKeys: [],
      fileForm: newEmptyStandardForm(),
      templateDialog: false,
      folderTable: [],
      currentRow: {},
      isSpec: 1,
      folderID: undefined,
      templateID: undefined,
      loading: false,
      templateIDCope: undefined,
      parentID: "",
      templateType: "",
      addTemplate: checkPermission(this.$allPerms.TEMPLATA_ADD_TEMPLATE),
      renameTemplate: checkPermission(this.$allPerms.TEMPLATA_RENAME_TEMPLATE),
      deleTemplate: checkPermission(this.$allPerms.TEMPLATA_DALE_TEMPLATE),
      copyTemplate: checkPermission(this.$allPerms.TEMPLATA_COPY_TEMPLATE),
      pasteTemplate: checkPermission(this.$allPerms.TEMPLATA_PASTE_TEMPLATE),
      peeraddFloder: checkPermission(this.$allPerms.TEMPLATA_PEERADD_FLODER),
      downaddFloder: checkPermission(this.$allPerms.TEMPLATA_DOWNADD_FLODER),
      deleFloder: checkPermission(this.$allPerms.TEMPLATA_DELE_FLODER),
      editFloder: checkPermission(this.$allPerms.TEMPLATA_EDIT_FLODER),
      moveUpFloder: checkPermission(this.$allPerms.TEMPLATA_MOVEUP_FLODER),
      moveDownFloder: checkPermission(this.$allPerms.TEMPLATA_MOVEDOWN_FLODER),

      treeAddDialog: false,
      treeRules: {
        folderName: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        folderSpec: [{ required: true, message: "请选择专业", trigger: "blur" }]
      },
      treeForm: {
        folderName: "",
        folderSpec: "",
        templateID: ""
      },
      expandRowKeys: [],
      templateTypeCat: ""
    };
  },
  computed: {
    templateTitle() {
      return ["同级添加文件夹", "降级添加文件夹", "修改文件夹"][this.templateType];
    },
    templateTitleCat() {
      return ["添加模板", "修改模板"][this.templateTypeCat];
    },
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    submitForm() {
      const {
        fileForm: { folderName, folderNameCn, parentID },
        templateID
      } = this;
      const params = {
        folderName,
        folderNameCn,
        folderType: 7,
        parentID: Array.isArray(parentID) ? parentID[parentID.length - 1] : parentID,
        templateID
      };
      return params;
    }
  },
  created() {
    this.getFrameTree();
    storage.remove("TemplateID1");
  },
  methods: {
    // 获取左侧模板
    getFrameTree() {
      this.frameTree = [];
      templateDirectory.getTree(this.enterpriseId).then(({ data }) => {
        const array = data;
        for (const item of array) {
          if (item.children && item.children.length > 0) {
            item.children = item.children.map(a => {
              return {
                name: a.folderName,
                id: a.templateID,
                ...a
              };
            });
            this.frameTree.push(item);
          } else {
            this.frameTree.push(item);
          }
        }
      });
    },
    // 选中节点
    currentOrgChangeHandler(val, node) {
      this.expandRowKeys = [];
      this.currentRow = val;
      this.isSpec = val.isSpec;
      this.templateID = val.id;
      this.folderTable = [];
      if (!val.isSpec) this.selectFolder(val.id);
    },
    //
    addTreeTemplate() {
      const a = disablePrompt();
      if (a) {
        this.treeAddDialog = true;
        this.$nextTick(() => {
          this.$refs.folderName.focus();
          this.$refs.treeForm.clearValidate();
        });
        this.templateTypeCat = 0;
        this.treeForm.folderSpec = this.currentRow.id;
      }
    },
    // 添加模板
    async templateBtn() {
      await this.$refs.treeForm.validate();
      const a = disablePrompt();
      if (a) {
        if (!this.treeForm.templateID) {
          templateDirectory
            .insertTree({
              folderName: this.treeForm.folderName,
              specID: this.treeForm.folderSpec,
              enterpriseId: this.enterpriseId
            })
            .then(data => {
              if (data.result === "0") {
                this.$message({
                  message: "添加成功",
                  type: "success"
                });
              } else {
                this.$message({
                  message: "添加失败",
                  type: "warning"
                });
              }
              this.getFrameTree();
              this.isSpec = 1;
              this.currentRow = {};
              this.treeAddDialog = false;
              this.treeGetReset();
            });
        } else {
          templateDirectory
            .standardRename({
              templateID: this.treeForm.templateID,
              folderName: this.treeForm.folderName,
              specId: this.treeForm.folderSpec,
              enterpriseId: this.enterpriseId
            })
            .then(data => {
              if (data.result === "0") {
                this.$message({
                  message: "修改成功",
                  type: "success"
                });
              } else {
                this.$message({
                  message: "修改失败",
                  type: "warning"
                });
              }
              this.getFrameTree();
              this.isSpec = 1;
              this.templateID = undefined;
              this.currentRow = {};
              this.treeAddDialog = false;
              this.treeGetReset();
            });
        }
      }
    },
    // 重命名
    renameTemplateBtn(data) {
      const a = disablePrompt();
      if (a) {
        this.treeAddDialog = true;
        this.templateTypeCat = 1;
        this.treeForm.folderName = data.name;
        this.treeForm.templateID = data.templateID;
        this.treeForm.folderSpec = data.specID;
      }
    },
    // 删除模板
    deleteTemplate(data) {
      const a = disablePrompt();
      if (a) {
        this.currentRow = data || {};
        const templateId = this.currentRow.templateID;
        const name = this.currentRow.name;
        this.$confirm(`您确定要删除分组 ${name} 吗?`, "警告", {
          type: "warning"
        })
          .then(() => templateDirectory.deleteTree(templateId))
          .then(data => {
            if (data.result === "0") {
              this.$message({
                message: "删除成功",
                type: "success",
                showClose: true
              });
            }
            this.getFrameTree();
            this.isSpec = 1;
            this.templateID = undefined;
            this.currentRow = {};
            this.folderTable = [];
          });
      }
    },
    // 查询文件夹
    selectFolder(val) {
      this.folderTable = [];
      this.folderID = undefined;
      templateDirectory.selectFolder(val, 0).then(({ data }) => {
        this.folderTable = this.getTreeData(data.folder) || [];

        if (!this.expandRowKeys.length) {
          this.expandRowKeys = data.folderIDList || [];
        }
      });
    },
    getTreeData(data) {
      for (var i = 0;i < data.length > 0;i++) {
        if (data[i].children == null || data[i].children.length <= 0) {
          data[i].children = undefined;
        } else {
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    handleDelete(val) {
      this.folderID = val.folderID;
      this.parentID = val.parentID;
    },
    expandChange({ folderID }, expanded) {
      if (expanded) {
        this.expandRowKeys.push(folderID);
      } else {
        const index = this.expandRowKeys.findIndex(id => id === folderID);
        if (index > 0) this.expandRowKeys.splice(index, 1);
      }
    },
    // 上移
    async upmoveBtn(val, row) {
      const a = disablePrompt();
      if (a) {
        if (row && row.folderID) {
          this.folderID = row.folderID;
          this.parentID = row.parentID;
        }
        const folderID = this.folderID;
        const templateID = this.templateID;
        const res = await templateDirectory.standardMove(folderID, val, templateID);
        if (res.result === "0") {
          this.$message({
            message: "移动成功",
            type: "success"
          });
          this.selectFolder(this.templateID);
        }
      }
    },
    async upgradeBtn(moveType, row) {
      const a = disablePrompt();
      if (a) {
        if (row && row.folderID) {
          this.folderID = row.folderID;
          this.parentID = row.parentID;
        }
        const folderID = this.folderID;
        const res = await templateDirectory.upAndDown(folderID, moveType);
        if (res.result === "0") {
          this.$message({
            message: `${moveType === 0 ? "升级" : "降级"}成功`,
            type: "success"
          });
          this.selectFolder(this.templateID);
        }
      }
    },
    async downmoveBtn(val, row) {
      const a = disablePrompt();
      if (a) {
        if (row && row.folderID) {
          this.folderID = row.folderID;
          this.parentID = row.parentID;
        }
        const folderID = this.folderID;
        const templateID = this.templateID;
        const res = await templateDirectory.standardMove(folderID, val, templateID);
        if (res.result === "0") {
          this.$message({
            message: "移动成功",
            type: "success"
          });
          this.selectFolder(this.templateID);
        }
      }
    },
    async deleteFileBtn(row) {
      const a = disablePrompt();
      if (a) {
        await this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        await templateDirectory.deleteFile(row.folderID);
        this.$message({
          showClose: true,
          type: "success",
          message: "删除成功"
        });
        this.selectFolder(this.templateID);
      }
    },
    // 同级添加
    peerAddBtn(row) {
      const a = disablePrompt();
      if (a) {
        this.templateDialog = true;
        this.templateType = 0;
        this.$nextTick(function() {
          this.$refs.folderName.focus();
          this.$refs.fileForm.clearValidate();
        });

        this.fileForm = newEmptyStandardForm();
        if (row && row.folderID) {
          this.folderID = row.folderID;
          this.parentID = row.parentID;
          this.fileForm.parentID = row.parentID;
        } else {
          this.fileForm.parentID = this.parentID;
        }
      }
    },
    async addtemplateBtn() {
      await this.$refs.fileForm.validate();
      const { submitForm: params } = this;
      const res = await templateDirectory.insertSameLevel(params);
      if (res.result === "0") {
        this.$message({ message: "添加成功", type: "success" });
      }
      this.selectFolder(this.templateID);
      this.getReset();
    },
    // 降级
    DemoteAddBtn(row) {
      const a = disablePrompt();
      if (a) {
        this.templateDialog = true;
        this.templateType = 1;
        this.$nextTick(function() {
          this.$refs.folderName.focus();
          this.$refs.fileForm.clearValidate();
        });
        this.fileForm = newEmptyStandardForm();
        if (row && row.folderID) {
          this.folderID = row.folderID;
          this.parentID = row.parentID;
          this.fileForm.parentID = row.folderID;
        }
      }
    },
    async demoteAddTemplateBtn() {
      await this.$refs.fileForm.validate();
      const { submitForm: params } = this;
      const res = await templateDirectory.insertSameLevel(params);
      if (res.result === "0") {
        this.$message({ message: "添加成功", type: "success" });
      }
      this.selectFolder(this.templateID);
      this.getReset();
    },
    async updateBtn(row) {
      const a = disablePrompt();
      if (a) {
        if (row && row.folderID) {
          this.folderID = row.folderID;
          this.parentID = row.parentID;
          this.fileForm.parentID = row.parentID;
        }
        this.templateDialog = true;
        this.$nextTick(function() {
          this.$refs.fileForm.clearValidate();
        });
        this.templateType = 2;
        const res = await templateDirectory.detailFile(this.folderID);
        this.fileForm = res.data;
      }
    },
    async updateAddTemplateBtn() {
      await this.$refs.fileForm.validate();
      const { submitForm: params } = this;
      params.folderID = this.folderID;
      const res = await templateDirectory.updateType(params);
      if (res.result === "0") {
        this.$message({ message: "修改成功", type: "success" });
      }
      this.selectFolder(this.templateID);
      this.getReset();
    },
    // 清空表单
    getReset() {
      this.$refs.fileForm.resetFields();
      this.templateDialog = false;
    },
    treeGetReset() {
      this.$refs.treeForm.resetFields();
      this.treeAddDialog = false;
      this.treeForm.templateID = "";
    },
    // 复制
    copyTemplateBtn() {
      const a = disablePrompt();
      if (a) {
        this.templateIDCope = this.templateID;
      }
    },
    async pasteTemplateBtn() {
      const a = disablePrompt();
      if (a) {
        const pastCode = this.templateID;
        const copyCode = this.templateIDCope;
        if (copyCode && pastCode && pastCode !== copyCode) {
          const res = await templateDirectory.copyFile(copyCode, pastCode);
          if (res.result === "0") {
            if (res.data) {
              this.$message({
                message: res.data,
                duration: 1500,
                type: "success"
              });
            } else this.$message.success("粘贴成功");
          }
          this.selectFolder(this.templateID);
          this.templateIDCope = undefined;
        } else {
          this.$message({
            message: "你选择复制与粘贴的属于同一模板，请重新进行选择要粘贴的模板",
            type: "warning"
          });
        }
      }
    },
    getIcon(level) {
      if (level === 1) return require("@/CommonDP/assets/doc/folderParent.png");
      return require("@/CommonDP/assets/doc/folderChild.png");
    }
  }
};
</script>
<style lang="scss" scoped>
$top-button-height: 42px;
$middle-height: 30px;
$left-width: 256px;
.bottom_tree_table {
  height: 100%;
  width: 100%;
  background-color: #fff;
  position: relative;
  min-width: 1050px;
  .bottom_left {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: $left-width;
    border-right: 1px solid #ebefff;
    .left_button {
      padding: var(--middle-space) var(--big-space);
    }
    .left_tree {
      overflow: auto;
      position: absolute;
      left: 3px;
      top: $top-button-height + 20px;
      bottom: 10px;
      right: 0;
      .tree_1 {
        font-size: 14px;
      }
      &_item {
        &_btn {
          position: absolute;
          right: 5px;
          visibility: hidden;
          i {
            cursor: pointer;
            font-size: 14px;
          }
        }

        &:hover {
          .left_tree_item_btn {
            visibility: visible;
          }
        }
      }
    }
    .textAll {
      width: 150px;
      font-size: 14px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .bottom_right {
    position: relative;
    margin-left: $left-width + 10px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .right_button {
      padding: var(--middle-space) var(--big-space);
    }
    .right_table {
      padding: 0 var(--big-space) var(--middle-space);
      height: 1px;
      flex-grow: 1;
      .el-table {
        height: 100%;
        overflow: auto;
      }

      .el-button {
        padding: 0 !important;
        line-height: 1 !important;
        font-size: 20px;
      }
      .el-button + .el-button {
        margin-left: 5px;
      }
      ::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
        td:first-child {
          padding-left: 23px;
        }
      }
    }
  }
}

/deep/.el-tree-node__content {
  height: 31px;
  line-height: 31px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
}
</style>
